import { ErrorOutline } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import './stylesDataConfirmation.css';

export default function ErrorMessage({ message, onRetry }) {

		const { t } = useTranslation('app');

    return(
		<div className='data-confirmation__loading'>
			<ErrorOutline style={{ color: 'red', fontSize: '5rem' }}/>
			<h1>{ t('errors.try_again') }</h1>
			<p>{message}</p>
			{onRetry && (
				<Button variant="contained" color="primary" onClick={onRetry}>
					Tentar novamente
				</Button>
			)}
		</div>
    );
}
